var TrendDiscView = Backbone.View.extend({

    initialize:function(params){
        var self = this;

        this.dataApp = params.dataApp;
        this.$TrendPage = $("#App[data-app='"+this.dataApp+"'] #TrendPage");
        this.$TrendDisc = $("#App[data-app='"+this.dataApp+"'] #TrendDisc");
        this.$TrendDiscBg = $("#App[data-app='"+this.dataApp+"'] #TrendDiscBg");
        this.$TrendDiscLinkTooltip = $("#App[data-app='"+this.dataApp+"'] #TrendDiscLinkTooltip");

        this.shiftDiff = {
            left:0,
            top:0
        };
 
        this.innerdiscsParams = {
            "act":{"dist":30},
            "prepare":{"dist":60},
            "watch":{"dist":90},
        };

        this.animatedTrends = {
            root:"",
            linked:[]
        };

        this.biggerCoeff = 1.5;
        this.smallerCoeff = 0.9;
    },

    render:function(){
        this.renderTrendDisc();
        this.bindEvents();
    },

    renderTrendDisc:function(){
        this.discSize = this.$TrendDisc.width();
        if(this.discSize > (App.appHeight)){
            this.discSize = App.appHeight;
        }
        this.$TrendDisc.css("height", this.discSize)
                        .css("width", this.discSize);
        /**_.each(this.innerdiscsParams, function(discData, index){
            $(".trenddisc_innerdisc[data-innerdisc='"+index+"']").css("width", discData.dist+"%")
                                                                .css("height", discData.dist+"%");
        });*/
    },

    update:function(trendID, fromTrend){
        var self = this;

        var trendType = "trends";
        if(this.dataApp == "second") trendType = "trendsSecond";

        var trendData = App.utils[trendType][trendID];
        this.animatedTrends.root = trendID;
        this.animatedTrends.linked = [];
        $("#App[data-app='"+this.dataApp+"'] .trend_circle").removeClass("root")
                        .removeClass("touchtapfordetails")
                        .attr("data-trendpagetext-position", "notset");

        var discViewSize = App.discView.discSize;
        
        if(self.dataApp != "first"){
            discViewSize = App.discViewSecond.discSize;
        }

        var $trendDiscRoot = $("<div class='trenddisc_root linked_circle' data-id='"+trendID+"'></div>");
        var discSize = ((App.utils.sizeRadiuses[trendData.size] * (discViewSize/App.utils.discSizeRef)) * 2);
        $trendDiscRoot.css("width", discSize * this.biggerCoeff)
                        .css("height", discSize * this.biggerCoeff);
        $("#App[data-app='"+this.dataApp+"'] .trend_circle[data-id='"+this.animatedTrends.root+"']").addClass("root");

        this.$TrendDisc.append($trendDiscRoot);

        var linkedTrends = [];
        _.each(trendData.links, function(link){
            var linkedTrend = _.find(App.utils[trendType], function(t){ return t.slugTrend == link; });
            if(linkedTrend !== undefined){
                linkedTrends.push(linkedTrend);
            }
        });

        var linkedTrendsByField = _.groupBy(linkedTrends, function(t){ return t.field; });
        _.each(linkedTrendsByField, function(linkedTrends, fieldID){
            self.updatePolarRow(fieldID, linkedTrends, trendID);
            /*var linkedTrendsByStatus = _.groupBy(linkedTrends, function(t){ return t.status; });
            _.each(linkedTrendsByStatus, function(linkedTrends, statusID){
                self.updatePolarRow(fieldID, statusID, linkedTrends);
            });*/
        });

        this.$TrendDiscBg.css("width", this.$TrendDisc.width())
                            .css("height", this.$TrendDisc.height())
                            .css("left", this.$TrendDisc.offset().left)
                            .css("top", this.$TrendDisc.offset().top);

        this.performAnimation(trendData, fromTrend);
    },

    updatePolarRow:function(fieldID, trends, rootTrendID){
        var self = this;
        var polarRowInc = 0;
        var polarRowRadius = 0;
        var center = self.discSize/2;

        var discViewFieldParams = App.discView.fieldsParams;
        var discViewSize = App.discView.discSize;

        if(self.dataApp != "first"){
            discViewFieldParams = App.discViewSecond.fieldsParams
            discViewSize = App.discViewSecond.discSize;
        }

        polarRowInc = (discViewFieldParams[fieldID].end - discViewFieldParams[fieldID].start) / (trends.length + 1);

        polarRowRadius = self.discSize / 4;

        var hasALot = false;
        if(trends.length >= 6) hasALot = true;
        _.each(trends, function(trend, inc){
            self.animatedTrends.linked.push(trend.id);
            var angle = discViewFieldParams[fieldID].start + polarRowInc*(inc+1);
            var radians = angle * Math.PI / 180;
            trendCircleX = center + polarRowRadius*Math.cos(radians);
            trendCircleY = center + polarRowRadius*Math.sin(radians);

            var $trendCircle = $(".trend_circle[data-id='"+trend.id+"']");
            var $linkedCircle = $("<div class='trenddisc_noroot linked_circle'></div>");
            var circleSize = ((App.utils.sizeRadiuses[trend.size] * (discViewSize/App.utils.discSizeRef)) * 2);

            $linkedCircle.css("left", trendCircleX)
                        .css("top", trendCircleY)
                        .css("width", circleSize * self.smallerCoeff)
                        .css("height", circleSize * self.smallerCoeff)
                        .attr("data-status", trend.status)
                        .attr("data-trend", trend.slugTrend)
                        .attr("data-id", trend.id)
                        .attr("data-level", trend.level);

            if(angle < -40){
                $trendCircle.attr("data-trendpagetext-position", "top");
            }else if(angle < 70){
                $trendCircle.attr("data-trendpagetext-position", "right");
            }else if(angle < 77){
                $trendCircle.attr("data-trendpagetext-position", "bottomright");
            }else if(angle < 113){
                $trendCircle.attr("data-trendpagetext-position", "bottom");
            }else if(angle < 120){
                $trendCircle.attr("data-trendpagetext-position", "bottomleft");
            }else if(angle < 240){
                $trendCircle.attr("data-trendpagetext-position", "left");
            }else if(angle < 330){
                $trendCircle.attr("data-trendpagetext-position", "top");
            }else{
                $trendCircle.attr("data-trendpagetext-position", "right");
            }

            /*if(!hasALot){
                $linkedCircle.addClass("forcedisplay");
            }
            else{
                if(inc%2 == 0) $linkedCircle.addClass("forcedisplay");
            }*/

            self.$TrendDisc.append($linkedCircle);
        });
    },

    performAnimation:function(trendData, fromTrend){
        var self = this;
        App.isClickable = false;
        console.log("performAnimation", this.dataApp);
        $("#App[data-app='"+this.dataApp+"'] #ActionsLegend").addClass("notdisplayed");
        var timeouts = {
            root:500,
            linked:500,
            rest:2000
        };

        if(App.utils.isTouchDevice()){
            timeouts.rest = 3000;
        }

        if(fromTrend){
            _.each($("#App[data-app='"+this.dataApp+"'] .trend_circle"), function(circle){
                var $circle = $(circle);
                var trendID = $circle.attr("data-id");
                if(_.indexOf(self.animatedTrends.linked, trendID) == -1 && trendID !== self.animatedTrends.root){
                    $circle.addClass("tobemasked");
                }
            });

            if(this.dataApp == "first") App.discView.mask();
            else App.discViewSecond.mask();

            timeouts.root = 300;
            timeouts.linked = 300;
            timeouts.rest = 1500;
        }else{
            //$("#Legend").addClass("notdisplayed");
            $("#App[data-app='"+this.dataApp+"'] #TrendLegend").addClass("notdisplayed");
            $("#App[data-app='"+this.dataApp+"'] .trend_circle").addClass("tobemasked");

            if(this.dataApp == "first") App.discView.mask();
            else App.discViewSecond.mask();
        }
        

        setTimeout(function(){

            if(self.dataApp == "first") App.discView.zoomZero();
            else App.discViewSecond.zoomZero();

            self.$TrendDiscBg.addClass("disopacified");
            self.performRootAnimation();
            App.$App.attr("data-page", App.currentPage);
            App.$AppSecond.attr("data-page", App.currentPage);
            App.$Body.attr("data-page", App.currentPage);
        }, timeouts.root);

        setTimeout(function(){
            self.performLinkedAnimation();
        }, timeouts.linked);

        this.updateText(trendData);
        setTimeout(function(){
            if(self.dataApp == "first") App.discView.displayTrendLinks(trendData.id, false);
            else App.discViewSecond.displayTrendLinks(trendData.id, false);

            $("#App[data-app='"+self.dataApp+"'] #TrendText").addClass("displayed");
            self.$TrendPage.addClass("disopacified");
            //$("#Legend").removeClass("notdisplayed");
            $("#App[data-app='"+self.dataApp+"'] #TrendLegend").removeClass("notdisplayed");
            App.isClickable = true;
        }, timeouts.rest)

        setTimeout(function(){
            self.createFakeTrendsLinks()
        }, timeouts.rest + 600);
    },

    createFakeTrendsLinks:function(){
        $("#App[data-app='"+this.dataApp+"'] #TrendDisc").find("#TrendDiscLinks").remove();
        var svgOuter = $("#App[data-app='"+this.dataApp+"'] #DiscLinks")[0].outerHTML;
        var $svgOuter = $(svgOuter);

        this.shiftDiff = {
            left: $("#App[data-app='"+this.dataApp+"'] #Disc").offset().left - $("#App[data-app='"+this.dataApp+"'] #TrendDisc").offset().left,
            top: $("#App[data-app='"+this.dataApp+"'] #Disc").offset().top - $("#App[data-app='"+this.dataApp+"'] #TrendDisc").offset().top
        }

        $svgOuter.css("margin-left", this.shiftDiff.left+"px")
                .css("margin-top", this.shiftDiff.top+"px")
        $("#App[data-app='"+this.dataApp+"'] #TrendDisc").append($svgOuter);
    },

    performRootAnimation:function(){
        this.performCircleAnimation(this.animatedTrends.root);
    },

    performLinkedAnimation:function(){
        var self = this;
        _.each(this.animatedTrends.linked, function(trendID){
            self.performCircleAnimation(trendID);
        });
    },

    performCircleAnimation:function(trendID){
        console.log("dataApp", this.dataApp);
        var $destCircle = $("#App[data-app='"+this.dataApp+"'] .linked_circle[data-id='"+trendID+"']");
        var $originCircle = $("#App[data-app='"+this.dataApp+"'] .trend_circle[data-id='"+trendID+"']");

        var destPosition = {
            left:$destCircle.offset().left + $destCircle.width()/2,
            top:$destCircle.offset().top + $destCircle.height()/2
        };

        var originOffsetPosition = {
            left:$originCircle.offset().left,
            top:$originCircle.offset().top
        };
        var originPosition = {
            left:$originCircle.position().left,
            top:$originCircle.position().top
        }

        $originCircle.css("left", originPosition.left - (originOffsetPosition.left - destPosition.left))
                    .css("top", originPosition.top - (originOffsetPosition.top - destPosition.top))
                    .css("width", $destCircle.width())
                    .css("height", $destCircle.height());

        /*if($destCircle.hasClass("forcedisplay")) $originCircle.addClass("forcedisplay");
        else $originCircle.removeClass("forcedisplay");*/

        setTimeout(function(){
            $originCircle.addClass("interpolating")
                    .removeClass("tobemasked")
                    .removeClass("masked");
        }, 600);
    },

    rollbackAnimation:function(){
        var self = this;
        App.isClickable = false;
        //$("#Legend").addClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #TrendLegend").addClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] .trend_circle").addClass("tobemasked");

        if(this.dataApp == "first"){
            App.discView.mask();
            App.discView.leaveTrend();
        }
        else{
            App.discViewSecond.mask();
            App.discViewSecond.leaveTrend();
        }

        
        if(this.dataApp == "first") App.currentPage = "disc";
        else App.currentPage = "disc2";

        App.selectedTrend = "";
        this.$TrendDiscBg.removeClass("disopacified");
        $("#App[data-app='"+this.dataApp+"'] #TrendText").removeClass("displayed");
        $("#App[data-app='"+this.dataApp+"'] #SearchInput").val("");

        setTimeout(function(){
            App.$App.attr("data-page", App.currentPage);
            App.$AppSecond.attr("data-page", App.currentPage);
            App.$Body.attr("data-page", App.currentPage);
             _.each($("#App[data-app='"+self.dataApp+"'] .trend_circle"), function(tCircle){
                var $trendCircle = $(tCircle);
                $trendCircle.removeClass("interpolating");
                
                var originSize = $trendCircle.attr("data-origin-size");
                $trendCircle.css("left", $trendCircle.attr("data-origin-left")+"px")
                            .css("top", $trendCircle.attr("data-origin-top")+"px")
                            .css("width", originSize+"px")
                            .css("height", originSize+"px");
            });
        }, 600);

        setTimeout(function(){
            $("#App[data-app='"+self.dataApp+"'] .trend_circle").removeClass("tobemasked")
                            .removeClass("masked");
            self.$TrendPage.removeClass("disopacified");

            if(self.dataApp == "first"){
                App.discView.unmask();
            }
            else{
                App.discViewSecond.unmask();
            }

            
            App.isClickable = true;
        }, 1200);

        setTimeout(function(){
            $("#App[data-app='"+self.dataApp+"'] #TrendDisc").empty();
            //$("#Legend").removeClass("notdisplayed");
            $("#App[data-app='"+self.dataApp+"'] #TrendLegend").removeClass("notdisplayed");
            
        }, 2000);
    
        App.router.updateRoute();
    },

    updateText:function(trendData){
        var self = this;

        var timeout = 0;
        if($("#App[data-app='"+this.dataApp+"'] #TrendText").hasClass("opacified")){
            timeout = 300;
        }

        setTimeout(function(){
            $("#App[data-app='"+self.dataApp+"'] #TrendText").attr("data-status", trendData.status);
            var statusLabel = App.utils.statusesLabel[trendData.status];
            self.$TrendPage.find(".status_label").html(statusLabel);
            self.$TrendPage.find(".text_title .title_value").html(trendData.trend);
            self.$TrendPage.find(".text_field").html(App.utils.fieldsData[trendData.field].label);
            self.$TrendPage.find(".text_chapo").html(trendData.chapo);
            if(trendData.chapo2 !== ""){
                $("#App[data-app='"+self.dataApp+"'] .text_atstake_wrapper").removeClass("nodata");
                self.$TrendPage.find(".text_atstake").html(trendData.chapo2);
            }else{
                $("#App[data-app='"+self.dataApp+"'] .text_atstake_wrapper").addClass("nodata");
            }

            if(trendData.companies !== ""){
                var splittedCompanies = trendData.companies.split(";");
                var htmlCompanies = "<ul class='companies_list'>";
                _.each(splittedCompanies, function(c){
                    htmlCompanies += "<li>"+c+"</li>";
                })
                htmlCompanies += "</ul>";
                self.$TrendPage.find(".text_companies").html(htmlCompanies);
            }
           
            if(trendData.contacts !== ""){
                var splittedContacts = trendData.contacts.split("\n");
                var splittedMails = trendData.mail.split("\n");
                var htmlContacts = "<ul class='contacts_list'>";
                _.each(splittedContacts, function(c, i){
                    htmlContacts += "<li><a href='mailto:"+splittedMails[i]+"?Subject="+trendData.trend+"'>"+c+"</a></li>";
                })
                htmlContacts += "</ul>";
                $("#App[data-app='"+self.dataApp+"'] .text_contacts").html(htmlContacts);
            }
        }, timeout);
    },

    bindEvents:function(){
        var self = this;
        
        $("#App[data-app='"+this.dataApp+"'] .page_backbt").on("click", function(){
            self.rollbackAnimation();
        });

        this.$TrendDisc.on("click", ".linked_circle", function(){
            if(!$(this).hasClass("trenddisc_root") && App.isClickable){
                $("#App[data-app='"+self.dataApp+"'] .trend_circle").removeClass("trendhovered")
                                .removeClass("trendhoveredout");
                $("#App[data-app='"+self.dataApp+"'] #TrendDisc").empty();

                if(self.dataApp == "first"){
                    App.discView.leaveTrend();
                }
                else{
                    App.discViewSecond.leaveTrend();
                }

                
                $("#App[data-app='"+self.dataApp+"'] #TrendText").addClass("opacified");
                App.selectTrend($(this).attr("data-id"), true);
                setTimeout(function(){
                    $("#App[data-app='"+self.dataApp+"'] #TrendText").removeClass("opacified");
                }, 300);
            }
        });

        this.$TrendDisc.on("mouseenter", ".linked_circle", function(){
            var trendID = $(this).attr("data-id");
            $("#App[data-app='"+self.dataApp+"'] .trend_circle[data-id='"+trendID+"']").addClass("trendhovered");
        });

        this.$TrendDisc.on("mouseleave", ".linked_circle", function(){
            $("#App[data-app='"+self.dataApp+"'] .trend_circle").removeClass("trendhovered")
                                .addClass("trendhoveredout");
            setTimeout(function(){
                $("#App[data-app='"+self.dataApp+"'] .trend_circle").removeClass("trendhoveredout");
            }, 300);
        });

        this.$TrendDisc.on("mouseenter", ".trend_link", function(){
            App.$trendLink = $(this);
            App.hoverTrendLink = true;
        });

        this.$TrendDisc.on("mouseleave", ".trend_link", function(){
            App.hoverTrendLink = false;
            var $trendLink = $(this);
            var originTrendID = $trendLink.attr("data-origin-trend");
            var destTrendID = $trendLink.attr("data-dest-trend");
            $("#App[data-app='"+self.dataApp+"'] #DiscLinks .trend_link[data-origin-trend='"+originTrendID+"'][data-dest-trend='"+destTrendID+"']").attr("data-hovered", "false");
            self.$TrendDiscLinkTooltip.removeClass("displayed");
        });

        $(document).on("mousemove", function(event){
            App.mouseX = event.pageX;
            App.mouseY = event.pageY;
            if(App.hoverTrendLink) self.displayTrendLinkTooltip(App.$trendLink)
        })
    },

    displayTrendLinkTooltip:function($trendLink){
        var originTrendID = $trendLink.attr("data-origin-trend");
        var destTrendID = $trendLink.attr("data-dest-trend");

        var hasLinkNew = false;
        var linkNewText = "";

        var trendType = "trends";
        if(this.dataApp == "second") trendType = "trendsSecond";

        _.each(App.utils[trendType][originTrendID].linksNew, function(linkNew){
            if(linkNew.trendID == destTrendID) {
                hasLinkNew = true;
                linkNewText = linkNew.linkText;
            }
        });

        if(hasLinkNew){
            $("#App[data-app='"+this.dataApp+"'] #DiscLinks .trend_link[data-origin-trend='"+originTrendID+"'][data-dest-trend='"+destTrendID+"']").attr("data-hovered", "true");

            var tooltipPosition = {
                left: App.mouseX - this.$TrendDisc.position().left,
                top: App.mouseY - this.$TrendDisc.position().top,
            }

            this.$TrendDiscLinkTooltip.css("left", tooltipPosition.left)
                                    .css("top", tooltipPosition.top - 30)
                                    .html(linkNewText)
                                    .addClass("displayed");
        } else {
            return false;
        }
    }

});

module.exports = TrendDiscView;